import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { TYPES } from 'action-types/bill-to-party';
import { callApiV3Get } from 'utilities/apiCaller';
import API from 'constants/api';
import { executeParallelRequests } from 'utilities/parallel-requests';

export const getAllBillToParties = (searchId: number, level: number) => {
	return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
		dispatch({ type: TYPES.FETCH_ALL_BILL_TO_PARTIES_PENDING });
		try {
			const apiPromises = [
				callApiV3Get(API.Partners.GetViewPartners, { 'SearchId': searchId, 'Level': level }),
				callApiV3Get(API.CostRevenue.GetCustomerMaster)
			];
			const results = await executeParallelRequests(apiPromises);
			const partnersResult = results.find(result => result.index === 0);
			const customerResult = results.find(result => result.index === 1);
			if (partnersResult?.success && customerResult?.success) {
				dispatch({
					type: TYPES.FETCH_ALL_BILL_TO_PARTIES_SUCCESS,
					payload: {
						partners: partnersResult.data?.data?.result,
						customers: customerResult.data?.data,
						errors: []
					}
				});
			} else if(partnersResult?.success && !customerResult?.success) {
				dispatch({
					type: TYPES.FETCH_ALL_BILL_TO_PARTIES_SUCCESS,
					payload: {
						partners: partnersResult.data?.data?.result,
						customers: null,
						errors: [{type: 'customers', error: customerResult?.error}]
					}
				});
			} else if(!partnersResult?.success && customerResult?.success) {
				dispatch({
					type: TYPES.FETCH_ALL_BILL_TO_PARTIES_SUCCESS,
					payload: {
						partners: null,
						customers: customerResult.data?.data,
						errors: [{type: 'partners', error: partnersResult?.error}]
					}
				});
			} else{
				dispatch({
					type: TYPES.FETCH_ALL_BILL_TO_PARTIES_ERROR,
					partners: null,
					customers: null,
					payload: {
						errors: [{type: 'partners', error: partnersResult?.error}, {type: 'customers', error: customerResult?.error}]
					}
				});
			}
		} catch (e) {
			dispatch({
				type: TYPES.FETCH_ALL_BILL_TO_PARTIES_ERROR,
				partners: null,
				customers: null,
				payload: {
					errors: [{type: 'partners', error: e}, {type: 'customers', error: e}]
				}
			});
		}
	};
};